import React from 'react'

function PrivacyPolicy() {
  return (
    <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 main_content_terms">
            <div className="row justify-content-center">
                <div className="col-12 text-center my-5">
                    <h1>Privacy & Policy</h1>
                  </div>
                  <div className="col-lg-10 col-11">
                    <div className="row pb-3">
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <p>LOOV, a product of <a target="_blank" rel="noopener noreferrer" href="https://msitpark.org/">MS IT PARK Pvt Ltd</a>, is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your information.</p>
                            </div>
                        </div>     
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>1. Information We Collect</h5>
                                <b>We collect the following information:</b>
                                <ul>
                                    <li>User account details (email, name, company name)</li>
                                    <li>Desktop activity metrics (application usage, URLs, screenshots, mouse/keyboard activity)</li>
                                    <li>Attendance logs (login, logout times)</li>
                                </ul>
                                <p>We do not collect passwords, personal file content, or keystrokes.</p>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>2. How We Use Your Information</h5>
                                <b>We use the information to:</b>
                                <ul>
                                    <li>Provide employee monitoring and productivity features</li>
                                    <li>Generate usage reports for employers</li>
                                    <li>Improve platform features and performance</li>
                                </ul>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>3. Data Storage & Security</h5>
                                <p>All data is stored securely with restricted access. We implement encryption and access control to prevent unauthorized access.</p>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>4. Data Sharing</h5>
                                <p>We do not sell or share your data with third parties, except when required by law or with your consent.</p>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>5. User Control</h5>
                                <p>Employers are responsible for informing and obtaining consent from their employees before monitoring begins.</p>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>6. Cookies & Analytics</h5>
                                <p>We use minimal cookies for session management and usage analysis. These do not contain personal information.</p>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>7. Data Retention</h5>
                                <p>We retain user data only as long as necessary for the purposes mentioned above, or as required by law.</p>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>8. Updates to this Policy</h5>
                                <p>We may update this Privacy Policy from time to time. Continued use of the platform constitutes acceptance of the revised policy.</p>
                            </div>
                        </div>      
                        <div className="col-12 inner_spliter">
                            <div className="row">
                                <h5>9. Contact Us</h5>
                                <p>For questions about this Privacy Policy, contact us at:<br/><a target="_blank" rel="noopener noreferrer" href="mailto:support@loov.in">support@loov.in</a></p>
                            </div>
                        </div>   
                    </div>
                  </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default PrivacyPolicy
